{
  "dependencies": {
    "@date-fns/tz": "1.2.0",
    "@expo/react-native-action-sheet": "4.1.1",
    "@hookform/resolvers": "5.1.1",
    "@intercom/intercom-react-native": "8.5.0",
    "@react-native-clipboard/clipboard": "1.16.2",
    "@react-native-masked-view/masked-view": "0.3.2",
    "@reduxjs/toolkit": "2.8.2",
    "@sentry/react-native": "6.15.1",
    "@stepapp/core": "workspace:*",
    "@stepapp/sentry": "workspace:*",
    "@stepapp/stripe": "workspace:*",
    "@stepapp/ui": "workspace:*",
    "@stripe/react-stripe-js": "3.7.0",
    "@stripe/stripe-js": "7.4.0",
    "@stripe/stripe-react-native": "0.48.0",
    "color": "5.0.0",
    "customerio-expo-plugin": "2.3.1",
    "customerio-reactnative": "4.3.1",
    "date-fns": "4.1.0",
    "expo": "53.0.12",
    "expo-application": "6.1.4",
    "expo-build-properties": "0.14.6",
    "expo-constants": "17.1.6",
    "expo-crypto": "14.1.5",
    "expo-device": "7.1.4",
    "expo-file-system": "18.1.10",
    "expo-image-manipulator": "13.1.7",
    "expo-insights": "0.9.3",
    "expo-localization": "16.1.5",
    "expo-location": "18.1.5",
    "expo-notifications": "0.31.3",
    "expo-router": "5.1.0",
    "expo-screen-orientation": "8.1.7",
    "expo-splash-screen": "0.30.9",
    "expo-status-bar": "2.2.3",
    "expo-system-ui": "5.0.9",
    "expo-updates": "0.28.15",
    "expo-web-browser": "14.2.0",
    "i18next": "25.2.1",
    "intl-pluralrules": "2.0.1",
    "posthog-js": "1.255.1",
    "posthog-react-native": "4.1.1",
    "raf": "3.4.1",
    "react": "19.0.0",
    "react-dom": "19.0.0",
    "react-hook-form": "7.58.1",
    "react-hotjar": "6.3.1",
    "react-i18next": "15.5.3",
    "react-modal": "3.16.3",
    "react-native": "0.79.4",
    "react-native-edge-to-edge": "1.6.1",
    "react-native-gesture-handler": "2.26.0",
    "react-native-get-random-values": "1.11.0",
    "react-native-mmkv": "3.3.0",
    "react-native-modal": "13.0.2",
    "react-native-reanimated": "3.18.0",
    "react-native-render-html": "6.3.4",
    "react-native-safe-area-context": "5.5.0",
    "react-native-screens": "4.11.1",
    "react-native-svg": "15.11.2",
    "react-native-web": "0.20.0",
    "react-redux": "9.2.0",
    "react-use-intercom": "5.4.3",
    "redux": "5.0.1",
    "redux-persist": "6.0.0",
    "rn-calendar-component": "0.5.1",
    "zod": "3.25.67"
  },
  "devDependencies": {
    "@babel/core": "7.27.4",
    "@babel/plugin-proposal-export-namespace-from": "7.18.9",
    "@stepapp/tools-typescript": "workspace:*",
    "babel-preset-expo": "13.2.1"
  },
  "main": "./index.ts",
  "name": "stepapp-customer",
  "scripts": {
    "android": "expo run:android",
    "build:android": "eas build --non-interactive --local --output ./app-build.aab --platform android -e",
    "build:ios": "eas build --non-interactive --local --output ./app-build.ipa --platform ios -e",
    "build:ota": "eas update --auto --clear-cache --non-interactive --branch",
    "build:web": "expo export -s --platform web",
    "clean": "rm -rf *.ipa *.aab build .expo .turbo node_modules dist ios android",
    "ios": "expo run:ios",
    "pods": "cd ios && pod install",
    "pods:update": "cd ios && pod update --repo-update",
    "prebuild": "expo prebuild --no-install --skip-dependency-update react-native,react,expo",
    "sourcemaps": "bunx sentry-expo-upload-sourcemaps dist",
    "start": "expo start --dev-client",
    "submit:android": "eas submit --non-interactive -p android --path ./app-build.aab -e",
    "submit:ios": "eas submit --non-interactive -p ios --path ./app-build.ipa -e",
    "type-check": "tsc --noEmit",
    "web": "expo start --web"
  },
  "trustedDependencies": [
    "customerio-reactnative",
    "dprint",
    "customerio-expo-plugin"
  ],
  "private": true,
  "version": "4.4.2"
}
